import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

const PageNotFound = () => {
  return (
    <Grid>
      <Header as="h1">Page not found</Header>
    </Grid>
  );
};

export default PageNotFound;
